import React from 'react';
import { Box, Typography, Container, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { ExploreOutlined, FolderOpen, EventNote, Description, Message, HelpOutline, Groups, TrendingUp, MapOutlined } from '@mui/icons-material';
import { Link } from 'react-scroll'; // Import react-scroll for the scrolling

const whatIDoList = [
  { icon: <EventNote color="secondary" />, text: 'Prepare for attorney and mediation meetings so you arrive organized and ready' },
  { icon: <FolderOpen color="secondary" />, text: 'Organize documents, timelines, and priorities so information is clear and accessible' },
  { icon: <Description color="secondary" />, text: 'Develop a lifestyle overview and financial summary to support legal and financial discussions' },
  { icon: <Message color="secondary" />, text: 'Think through what and when to communicate before sending difficult messages' },
  { icon: <HelpOutline color="secondary" />, text: 'Talk through major decisions so they are made with clarity rather than panic' },
  { icon: <Groups color="secondary" />, text: 'Plan for parenting challenges and practical transitions during the process' },
  { icon: <TrendingUp color="secondary" />, text: 'Build emotional resilience during moments when the situation becomes overwhelming' },
  { icon: <MapOutlined color="secondary" />, text: 'Map out next steps so you stay focused on moving forward' },
];

const ServicesSection = () => {
  return (
    <Box id="services"
          sx={{
            py: { xs: 8, sm: 10, md: 15 },
            px: 3,
            bgcolor: '#f9f9f9',
          }}
    >
      <Container maxWidth="md">
        <Box sx={{ mb: 6 }}>
          <Typography variant="h4" gutterBottom>
            How I Help
          </Typography>
          <Typography sx={{ mb: 3 }}>
            Divorce can feel chaotic, especially when decisions must be made quickly, and the stakes are high.
            My role is to help you bring organization, preparation, and steady thinking to the process so you can move forward with greater clarity and confidence.
          </Typography>
          <Typography sx={{ mb: 1 }}>
            Together we may:
          </Typography>
          <List sx={{ mb: 2 }}>
            {whatIDoList.map((item, index) => (
              <ListItem key={index} sx={{ pl: 0 }}>
                <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))}
          </List>
          <Typography sx={{ mb: 2 }}>
            I don’t provide legal advice or interpret legal strategy. My role is helping you stay organized and prepared so you can make the best use of your legal and professional team.
          </Typography>
        </Box>

        {/* How We Work Together */}
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="h4" gutterBottom>
            How We Work Together
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            We meet virtually—on your schedule—in a private, judgment-free space where you can think, vent, plan, and act. If you're nearby, I also offer in-person sessions at my Jersey City, NJ office.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Whether you're just starting to consider divorce, knee-deep in the process, or rebuilding after, I meet you exactly where you are.
          </Typography>
          <Link to="contact" smooth={true} duration={600}>
            <Button variant="contained" color="secondary" size="large" startIcon={<ExploreOutlined />}>
              Explore Working Together
            </Button>
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default ServicesSection;